import React from 'react';

interface Props {
    options: any[];
    label?: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    selectedOption: any;
    name: string;
    width?: string;
    isProductOptions: boolean;
    isReceiverFit?: boolean;
    isNonUnique?: boolean;
}

const SelectButton: React.FC<Props> = ({
    options,
    label,
    selectedOption,
    onChange,
    name,
    width,
    isProductOptions,
    isReceiverFit,
    isNonUnique,
}) => {
    return (
        <div>
            {label && (
                <div className="row">
                    <div className="col-md-12">
                        <h4>{label}</h4>
                    </div>
                </div>
            )}
            <div className="col-md-12">
                {options
                    .filter(
                        (x) =>
                            !isProductOptions ||
                            (x.isAvailableLeft && x.isAvailableRight)
                    )
                    .map((option) => {
                        return (
                            <p
                                className="color-select"
                                key={option.text}
                                style={{
                                    marginRight: '10px',
                                    width: width ? width : '',
                                }}
                            >
                                <input
                                    type="radio"
                                    name={name}
                                    id={
                                        isNonUnique
                                            ? option.value + option.text
                                            : isReceiverFit
                                            ? option.value
                                            : option.text
                                    }
                                    value={option.value}
                                    checked={selectedOption === option.value}
                                    onChange={onChange}
                                />
                                <label
                                    className="btn button-label no-text-transform"
                                    style={{
                                        border: '1px solid #1e9be9',
                                    }}
                                    htmlFor={
                                        isNonUnique
                                            ? option.value + option.text
                                            : isReceiverFit
                                            ? option.value
                                            : option.text
                                    }
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            selectedOption === option.value
                                                ? `&#x2611  ${option.text}`
                                                : `&#9744  ${option.text}`,
                                    }}
                                />
                            </p>
                        );
                    })}
            </div>
        </div>
    );
};

export default SelectButton;
